import React from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'

import { Txt, Card, Icon } from '../../../../components'
import { getEventLocationToShow } from '../../../../tools/dataParse'
import { useTheme } from '../../../../theming/ThemeProvider'
import { getEventTypeName } from '../../../../tools/objectMapValues'
import { useLargeStyles } from './useStyles'
import { usePlatforms } from '../../../../hooks/usePlatforms'
import MobileEventCard from './index.js'

export default function EventCard ({ event }) {
  const { theme } = useTheme()
  const { isTablet } = usePlatforms()
  const styles = useLargeStyles(theme)

  const eventTypeName = getEventTypeName(event.type)
  const eventLocationToShow = getEventLocationToShow(event)

  return isTablet ? (
    <View style={styles.container}>
      <View style={styles.hour}>
        <Txt
          text={event.start}
          identity='body2Bold'
          style={styles.startHour}
          color='SLATE_GRAY'
        />
        {Boolean(event.end) && (
          <View style={styles.endHour}>
            <Icon
              name='HourArrow'
              width={8}
              height={8}
              fill={theme.SLATE_GRAY}
              style={styles.arrow}
            />
            <Txt
              text={event.end}
              identity='body3'
              color='SLATE_GRAY'
              style={styles.end}
            />
          </View>
        )}
      </View>
      <Card
        containerStyle={styles.card}
        contentStyle={styles.content}
      >
        <View style={styles.header}>
          <View style={styles.typeBadge}>
            <Txt
              text={eventTypeName}
              identity='body3'
              color='WHITE_TEXT'
            />
          </View>
          <View style={styles.number}>
            <Txt
              text='Order '
              identity='body2'
              color='SLATE_GRAY'
            />
            <Txt
              text={event.orderNumber}
              identity='body2Bold'
              color='SLATE_GRAY'
            />
          </View>
        </View>
        <Txt
          text='Stops at:'
          identity='body3'
          color='SLATE_GRAY'
          style={styles.stops}
        />
        <View style={styles.description}>
          <View style={styles.location}>
            <Txt
              text={eventLocationToShow}
              identity='body2'
            />
          </View>
          <View style={styles.address}>
            <Txt
              text={event.address}
              identity='body2'
            />
            <Txt
              text={event.location}
              identity='body2Bold'
            />
          </View>
        </View>
      </Card>
    </View>
  ) : <MobileEventCard event={event} />
}

EventCard.propTypes = {
  event: PropTypes.object.isRequired
}

EventCard.defaultProps = {
  event: {}
}
